import { getLatAndLong } from '@/utils';
import { tplLib } from '../../templateLib';

export async function store(userType, code, tpl) {
  const basicStore = {
    namespaced: true,
    state: () => {
      return {
        tplCode: tpl,
        tplName: tplLib[tpl] && tplLib[tpl].tplName,
        code,
        locationObj: {}
      };
    },
    actions: {
      async loadLocationData({ commit }) {
        const isNeedLau = tpl == 0;
        const locationObj = await getLatAndLong(true, isNeedLau);
        commit('setLocationData', locationObj);
      }
    },
    mutations: {
      setLocationData(state, locationObj) {
        state.locationObj = locationObj;
      }
    }
  };
  if (!tplLib[tpl]) {
    throw new Error(`模板不存在：${tpl}`);
  }
  if (tplLib[tpl].store) {
    basicStore.modules = {
      [tplLib[tpl].tplName]: await tplLib[tpl].store()
    };
  }
  return basicStore;
}
